import { IFullQuestionnaire } from '../interfaces/questionnaire';
import api from './api';

export interface CreateQuestionnaireData {
  nome: string;
  descricao: string;
  is_modelo: boolean;
  empresa_id: number;
  framework?: string;
  dominio_id?: number;
  pergunta_principal?: string;
  tipo_resposta?: 'TEXTO_LIVRE' | 'SIM_NAO' | 'PERCENTUAL' | 'MULTIPLA_ESCOLHA';
}

export interface UpdateQuestionnaireData extends Omit<CreateQuestionnaireData, 'empresa_id'> {
  id: number;
}

class QuestionnaireService {
  async getAll(): Promise<IFullQuestionnaire[]> {
    const response = await api.getQuestionnaires();
    return response.success ? (response.data as IFullQuestionnaire[]) : [];
  }

  async create(questionnaireData: CreateQuestionnaireData): Promise<IFullQuestionnaire | null> {
    const response = await api.createQuestionnaire(questionnaireData);
    return response.success ? (response.data as IFullQuestionnaire) : null;
  }

  async clone(id: number, cloneData: { nome: string; empresa_id: number; framework?: string; dominio_id?: number; pergunta_principal?: string; tipo_resposta?: 'TEXTO_LIVRE' | 'SIM_NAO' | 'PERCENTUAL' | 'MULTIPLA_ESCOLHA' }): Promise<IFullQuestionnaire | null> {
    const response = await api.cloneQuestionnaire(id, cloneData);
    return response.success ? (response.data as IFullQuestionnaire) : null;
  }

  // Métodos ainda não implementados na API
    async update(id: number, questionnaireData: UpdateQuestionnaireData): Promise<IFullQuestionnaire | null> {
      const response = await api.updateQuestionnaire?.(id, questionnaireData);
      return response?.success ? (response.data as IFullQuestionnaire) : null;
    }

  async delete(id: number): Promise<boolean> {
    const response = await api.deleteQuestionnaire(id);
    return response.success || false;
  }

  // async getById(id: number): Promise<IFullQuestionnaire | null> {
  //   const response = await api.getQuestionnaire?.(id);
  //   return response?.success ? (response.data as IFullQuestionnaire) : null;
  // }
}

export const questionnaireService = new QuestionnaireService();